var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"ma-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('fude-table',{attrs:{"settings":_vm.settings}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }